import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styles/AboutUs.css";

import meetingImg from "../assets/meet1.jpg";
import hrLadyImg from "../assets/meet2.jpg";

const AboutUs = () => {
  return (
    <div className="aboutus-wrapper" id="about">
      <section className="aboutus-section container py-4">
        <div className="row align-items-center g-4">
          <div className="col-lg-4 position-relative about-sub">
            <div className="card aboutus-card">
              <img
                src={meetingImg}
                alt="Team Meeting"
                className="img-fluid rounded"
              />
            </div>
          </div>

          <div className="col-lg-7 aboutus-text">
            <h6 className="aboutus-subheading">ABOUT US</h6>
            
            <h3 className="aboutus-heading mb-3">
              HR GROWTH AND COLLABORATION
            </h3>
            <p>
              Join the National Human Resources Club — a vibrant global community of HR professionals dedicated to growth, collaboration, and innovation. We provide global networking opportunities, foster knowledge-sharing, and support lasting excellence in human resources.
              At NHRC, we believe people are the heart of every organization.

            </p>
          </div>
        </div>
      </section>

      <section className="aboutus-section container py-4">
        <div className="row align-items-center g-4">
          <div className="col-lg-7 aboutus-text about-sub">
            <h3 className="aboutus-heading mb-3">OUR GOALS & PURPOSE</h3>
            <p>
              Our goal is to build a strong global community of HR professionals who learn, grow, and thrive together. Our purpose is to provide a platform for knowledge-sharing, leadership development, and meaningful collaboration that elevates the HR field worldwide.

We are committed to inspiring continuous improvement in HR practices, 
            </p>
          </div>
          <div className="col-lg-4 position-relative">
            <div className="blue-shape"></div>
            <div className="card aboutus-card">
              <img
                src={hrLadyImg}
                alt="Team Meeting"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
